import flatMap from 'lodash/flatMap';

import {Segmentation} from '../../property-filter-menu/models/segfilter';
import {SerializedBehaviorDictionary} from 'common/widgets/cohorts-query-builder/models/types/serialized-cohort-types';
import {Expression} from 'common/widgets/cohorts-query-builder/models/types/expression-types';
import {ResourceType} from 'common/widgets/property-filter-menu/models/types';
import {QueryCohortEntry} from 'common/widgets/query-event-selector/types';

export interface SavedCohortSegment {
  cohort: {
    id: number;
    name?: string;
    negated: boolean;
    data_group_id?: string;
  };
}

export interface InlineCohortSegment {
  cohort: {
    name?: string;
    raw_cohort: {
      name: string;
      behaviors: SerializedBehaviorDictionary;
      selector: Expression;
      data_group_id?: string;
    };
    negated: boolean;
  };
}

export function isCohortSegment(segment: Segment): segment is CohortSegment[] {
  return Array.isArray(segment) && segment[0].hasOwnProperty(`cohort`);
}
export type CohortSegment = SavedCohortSegment | InlineCohortSegment;

export function isCohortSegmentItem(item: QueryCohortEntry | CohortSegment): item is CohortSegment {
  return item.hasOwnProperty(`cohort`);
}

export function isInlineCohortSegment(segment: CohortSegment): segment is InlineCohortSegment {
  return !!(segment as InlineCohortSegment).cohort.raw_cohort;
}

export function isUserSegment(segment: Segment): segment is UserSegment {
  return segment.hasOwnProperty(`user`);
}
export interface UserSegment {
  user: Segmentation;
}

export function isEventSegment(segment: Segment): segment is EventSegment {
  return segment.hasOwnProperty(`event`);
}
export interface EventSegment {
  event: Segmentation;
}

export function isOtherSegment(segment: Segment): segment is OtherSegment {
  return segment.hasOwnProperty(`other`);
}
export interface OtherSegment {
  other: {
    value: string;
  };
}

/** A single segment for breaking down a query */
export type Segment = EventSegment | UserSegment | CohortSegment[] | OtherSegment;

/**
 * Infers selection type from the first selected segment
 * TODO: this will change in the future for multi-segment
 */
export function getSegmentType(selection: Segment | Segment[]): ResourceType {
  const hasSelected = Array.isArray(selection) && selection.length && selection[0];

  if (!hasSelected) {
    return null;
  }

  const selectionItem = flatMap(selection)[0];
  return Object.values(ResourceType).find((resourceType) => resourceType in selectionItem) || null;
}
